// src/app/features/auth/api/login.ts
//
// Transport layer for representative login. Thin wrapper over the shared
// apiClient instance -- no endpoint knowledge lives in core-api or in
// apiClient.ts itself, per their module docs.

import { apiClient } from '../../../api/apiClient';

export interface LoginRequestDTO {
  mobile: string;
  password: string;
}

export interface RepresentativeDTO {
  id: number | string;
  mobile: string;
  full_name?: string | null;
  avatar_url?: string | null;
}

export interface LoginResponseDTO {
  access_token: string;
  token_type: string;
  expires_at: string;
  representative: RepresentativeDTO;
  tenant_id: number;
  roles: unknown[];
}

/** POST /api/representative/auth/login -- tenant is resolved from request host. */
export async function loginRepresentative(
  payload: LoginRequestDTO
): Promise<LoginResponseDTO> {
  const { data } = await apiClient.post<LoginResponseDTO>(
    '/api/representative/auth/login',
    payload,
    { skipAuth: true }
  );
  return data;
}
